// Shared platform detection (DEV_TECH_DESIGN-0030 §5.3). Single source of
// truth for the onboarding page and the context-panel CTA so they never
// disagree about which branch a visitor sees.

export function isMobile() {
    const uaData = navigator.userAgentData;
    if (uaData && uaData.mobile === true) return true;
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
}

// Returns "windows" | "macos" | "mobile" | "other". Prefers the client-hint
// platform; falls back to the UA string. navigator.platform is deliberately
// not consulted — devtools UA spoofing does not override it, so it would
// mask the macOS/mobile branches during testing.
export function getPlatform() {
    if (isMobile()) return 'mobile';
    const uaData = navigator.userAgentData;
    const hintPlatform = (uaData && uaData.platform) || '';
    if (hintPlatform) {
        if (/win/i.test(hintPlatform)) return 'windows';
        if (/mac/i.test(hintPlatform)) return 'macos';
        return 'other';
    }
    const ua = navigator.userAgent || '';
    if (/Windows/i.test(ua)) return 'windows';
    if (/Macintosh|Mac OS X/i.test(ua)) return 'macos';
    return 'other';
}
